import { DocumentoPreEditado } from './DocumentoPreEditado';

export class DocumentoPreEditadoRtn {
    success: string;
    message: string;
    data: DocumentoPreEditado;
}
